import {
    DemandInformationCategory,
    DemandInformationOffers,
    DemandInformationVessel,
} from '../../../types/DemandInformationMessage';

export const getMatchingDemandOffer = (row: DemandInformationCategory, vessel: DemandInformationVessel) =>
    vessel.offers.find((offer: DemandInformationOffers) =>
        offer.items.some((item) => item.tankCategory === row.tankCategory)
    );
